import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Dialog, DialogBody } from '@blueprintjs/core';
import { css } from '@emotion/react';
import { StructureEditor } from 'react-ocl/full';
export function DatabaseStructureSearchModal({ onChange, isOpen, idCode, onClose, }) {
    return (_jsx(Dialog, { isOpen: isOpen, onClose: () => {
            onClose?.();
        }, style: { width: 720 }, title: "Search by structure", children: _jsx(DialogBody, { css: css `
          background-color: white;
        `, children: _jsx(StructureEditor, { initialIDCode: idCode, svgMenu: true, fragment: true, onChange: (molFile, molecule, idCode) => onChange(idCode) }) }) }));
}
